window.reInitYotpoWidgets = () => {
  if (yotpo === undefined) return;
  let yotpoApi = new Yotpo.API(yotpo);
  yotpoApi.refreshWidgets();
};

const mobileDrawerCountrySelectorHandling = () => {
  const container = document.querySelector(
    ".mobile-navigation-drawer__footer .promo-bar--country-selector"
  );
  const linksContainer = container.querySelector(".country-options");
  const toggler = container.querySelector(".active-store-text");

  toggler.addEventListener("click", () => {
    container.classList.toggle("expanded");
  });
};

const handleMobileDrawerMenu = () => {
  if (window.innerWidth > 767) return;
  const [...secondMobileContainers] = document.querySelectorAll(
    ".mobile-navigation-drawer .navigation__tier-2-container"
  );
  const mutationTypes = ["attributes"];

  const observer = new MutationObserver((mutList, obs) => {
    mutList.forEach((mutation) => {
      if (!mutationTypes.includes(mutation.type)) return;
      const firstChildren = mutation.target.querySelector(
        ".navigation__item a"
      );
      firstChildren && firstChildren.click();
    });
  });

  secondMobileContainers.forEach((elem) =>
    observer.observe(elem, { attributes: true })
  );
};

const geoIpPopupHandler = () => {
  document.addEventListener("click", ({ target }) => {
    const isCloseBtn = target.closest("#spicegems_cr_btn_no");
    if (!!!isCloseBtn) return;

    const modalGeo = target.closest("#sg_country_redirect_mod");
    modalGeo && modalGeo.remove();
  });
};

const pdpYotpoModifications = () => {
  if (!location.pathname.includes("/products/")) return;
  const yotpoSection = document.querySelector(".yotpo.yotpo-main-widget");

  const fixYotpoLayout = () => {
    const btnsContainer = yotpoSection.querySelector(
      ".write-question-review-buttons-container"
    );
    const filterSection = yotpoSection.querySelector(".yotpo-reviews-filters");
    const filtersContainer = yotpoSection.querySelector(".filters-container");
    const starReviewItemsContainer = yotpoSection.querySelector(
      ".bottom-line-items"
    );

    filterSection && filterSection.appendChild(btnsContainer);

    const starReviewSubcontainer = document.createElement("div");
    starReviewSubcontainer.classList.add("star-review-subcontainer");
    [...starReviewItemsContainer.children]
      .slice(1)
      .forEach((elem) => starReviewSubcontainer.appendChild(elem));
    starReviewItemsContainer.appendChild(starReviewSubcontainer);

    const [...yotpoStarsNoReviews] = document.querySelectorAll(
      ".write-review-btn-hidden"
    );
    yotpoStarsNoReviews.forEach((x) => (x.textContent = "No Reviews Yet"));

    const yotpoSortContainer = yotpoSection.querySelector(
      ".sort-drop-down.yotpo-nav-dropdown"
    );
    if (!!!yotpoSortContainer) return;

    const inputSearchContainer = filterSection.querySelector(
      ".free-text-search"
    );
    const inputSearch = inputSearchContainer.querySelector(
      ".free-text-search-input"
    );
    const sortList = yotpoSortContainer.querySelector(
      ".yotpo-dropdown.list-categories"
    );
    const [...sortOptions] = sortList.children;

    const newSortList = sortList.cloneNode(true);
    newSortList.children[0].remove();
    const [...newSortOptions] = newSortList.children;

    const stbSortList = document.createElement("div");
    const selectedSortOption = document.createElement("span");
    selectedSortOption.textContent = "Sort By";

    stbSortList.insertAdjacentHTML(
      "afterbegin",
      `
            <svg width="15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.1402 2.26822C14.5645 1.91466 14.6218 1.28409 14.2682 0.859816C13.9147 0.435539 13.2841 0.378215 12.8598 0.731779L14.1402 2.26822ZM7.5 6.5L6.85982 7.26822L7.5 7.80171L8.14018 7.26822L7.5 6.5ZM2.14018 0.731778C1.71591 0.378214 1.08534 0.435538 0.731779 0.859814C0.378215 1.28409 0.435539 1.91466 0.859816 2.26822L2.14018 0.731778ZM12.8598 0.731779L6.85982 5.73178L8.14018 7.26822L14.1402 2.26822L12.8598 0.731779ZM8.14018 5.73178L2.14018 0.731778L0.859816 2.26822L6.85982 7.26822L8.14018 5.73178Z" fill="#354145"/>
            </svg>
        `
    );
    stbSortList.appendChild(selectedSortOption);
    stbSortList.appendChild(newSortList);

    stbSortList.classList.add("stb-yotpo-sort-dropdown");
    inputSearchContainer.insertAdjacentElement("afterend", stbSortList);

    document.addEventListener("click", ({ target }) => {
      if (!!!target.closest(".stb-yotpo-sort-dropdown")) {
        if (!!target.closest(".desktop-clear-all-btn")) {
          selectedSortOption.textContent = "Sort By";
        }

        stbSortList.classList.remove("opened");
        return;
      }
    });

    stbSortList.addEventListener("click", () => {
      stbSortList.classList.toggle("opened");
    });

    newSortOptions.forEach((x, i) => {
      x.addEventListener("click", (evt) => {
        evt.preventDefault();
        sortOptions[i + 1].click();

        selectedSortOption.textContent = `Sort By: ${x.children[0].textContent}`;
      });
    });
  };

  const initWaiting = () => {
    const waitForYotpo = setInterval(() => {
      if (yotpoSection) {
        if (
          yotpoSection.classList.contains(
            ".write-question-review-buttons-container"
          )
        ) {
          const btnsContainer = yotpoSection.querySelector(
            ".write-question-review-buttons-container"
          );
          if (!!btnsContainer) {
            fixYotpoLayout();
            clearInterval(waitForYotpo);
          }
        }
      }
    }, 250);
  };

  setTimeout(initWaiting, 750);
};

const pdpOurCommitmentHandling = () => {
  const commitmentList = document.querySelector(".our-commitment-list");
  if (!!!commitmentList) return;
  const [...controlArrows] = commitmentList.parentElement.querySelectorAll(
    ".left-control, .right-control"
  );
  const [...commitments] = commitmentList.children;
  const getActiveGroup = () =>
    commitments.findIndex((x) => x.classList.contains("active"));
  const swipeGroup = (direction) => {
    commitments.forEach((x) => x.classList.add(`${direction}-transition`));
    setTimeout(
      () =>
        commitments.forEach((x) =>
          x.classList.remove(`${direction}-transition`)
        ),
      275
    );
  };

  const setNewActiveByIndex = (oldIndex, newIndex) => {
    commitments[oldIndex].classList.remove("active");
    commitments[newIndex].classList.add("active");
  };

  controlArrows.forEach((arrow) => {
    arrow.addEventListener("click", () => {
      const isLeft = arrow.classList.contains("left-control");
      let activeIndex = getActiveGroup();
      let newIndex;

      if (isLeft) {
        newIndex = activeIndex === 0 ? commitments.length - 1 : activeIndex - 1;
      } else {
        newIndex = activeIndex === commitments.length - 1 ? 0 : activeIndex + 1;
      }

      swipeGroup(isLeft ? "left" : "right");
      setTimeout(() => setNewActiveByIndex(activeIndex, newIndex), 250);
    });
  });
};

const pdpFormQuantityHandler = ({ detail } = { detail: {} }) => {
  const { quantity } = detail;
  if (!location.pathname.includes("/products/") || !!!quantity) return;
  const realQty = document.querySelector('#quantity[name="quantity"]');
  const hiddenQty = document.querySelector("[data-custom-quantity]");
  hiddenQty.value = quantity;
};

window.addEventListener("custom::qtyChanged", pdpFormQuantityHandler);

window.addEventListener("custom::mobileDrawerFilled", () => {
  mobileDrawerCountrySelectorHandling();
  handleMobileDrawerMenu();
});

const generateProductHTML = (product) => {
  const { id, title, url, image, price, images, metafields, tags } = product;
  const { image_banner } = metafields;

  const productBadges = [
    "award winner",
    "best seller",
    "limited edition",
    "new",
    "back in stock",
  ];

  const badgeConfig = {
    "award winner": { class: "badge--award-winner", text: "Award Winner" },
    "best seller": { class: "badge--best-seller", text: "Best Seller" },
    "limited edition": {
      class: "badge--limited-edition",
      text: "Limited Edition",
    },
    new: { class: "badge--new", text: "New" },
    "back in stock": { class: "badge--back-in-stock", text: "Back in Stock" },
  };

  const isAwardWinner = tags.includes("award winner");

  return `
    <div data-product-id="${id}" class="product-block product-card-updated">
      <div class="block-inner">
        <div class="block-inner-inner">
          <div class="image-cont">
          
           ${image_banner ?
            `
            <div class="badge-image--container">
              <img width="100" height="100" loading="lazy" src="${image_banner}" alt="badge for product ${title}">
            </div>
          ` : ''}
          
            <a class="product-link" href="${url}">
              <img 
                src="${image}" 
                alt="${title}" 
                class="product-image"
                loading="ease"
              >
            </a>
          </div>
          ${
            images.length > 1
              ? `
            <div class="image-cont image-cont__hover">
                <a href="${url}" class="product-block__gallery-item">
                  <img src="${images[1]}" alt="${title}" loading="lazy">
                </a>
            </div>
          `
              : ""
          }
          <div class="product-info">
            <a class="product-link" href="${url}">
              <div class="product-block__title">${title}</div>
              <div class="product-block__price">
                <span class="price">${price}</span>
              </div>
            </a>
          </div>
  
          <div class="product-block__badge">
            ${isAwardWinner ?
              `
              <span
                class="badge badge--award-winner"
                >Award Winner</span
              >
            ` : ''}
          </div>
        </div>
      </div>
    </div>
  `;
};

const fetchSearchByQuery = async (query) => {
  const containerResults = document.querySelector(".main-search__results");
  if (!containerResults) {
    console.error("No se encontró el contenedor de resultados.");
    return;
  }

  try {
    const response = await fetch(
      `/search?type=product&q=${encodeURIComponent(query)}`
    );
    if (!response.ok) throw new Error("Error fetching search results");

    const htmlResponse = await response.text();
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlResponse;

    const resultScript = tempDiv.querySelector("[data-result-ajax]");
    if (!resultScript) {
      console.error("No findings script tag in search results.");
      containerResults.innerHTML = "";
      return;
    }

    let jsonResults;
    try {
      jsonResults = JSON.parse(resultScript.innerHTML);
    } catch (parseError) {
      console.error("Error:", parseError);
      containerResults.innerHTML = "";
      return;
    }

    if (!jsonResults || !Array.isArray(jsonResults)) {
      console.error("Data no is valid");
      containerResults.innerHTML = "";
      return;
    }

    const html = jsonResults.length != 0 ? `
     <div class="search-results__container"> 
      <div class="search-results__header_ajax">
        ${jsonResults.map((product) => generateProductHTML(product)).join("")}
      </div>
      <a class="main-search__results-all-link button altcolour" href="/search?type=product&q=${encodeURIComponent(
        query
      )}">See all results</a> 
    </div>
    `: `<div class="search-results__header_ajax">We found 0 results</div>`;

    containerResults.innerHTML = html;
  } catch (error) {
    console.error("Error in search:", error);
    containerResults.innerHTML = "";
  }
};

const searchFormInit = () => {
  const formSearchHeader = document.querySelector(
    ".section-header .main-search__form"
  );

  if (!formSearchHeader) return;
  const inputSubmit = formSearchHeader.querySelector(".main-search__button");
  const inputText = formSearchHeader.querySelector('[name="q"]');
  const cleanButtonText = document.querySelector(
    "button.main-search__close.button.notabutton"
  );

  inputSubmit?.addEventListener("click", () => {
    formSearchHeader.preventDefault();
    const formInit = new FormData(formSearchHeader);
    const searchQuery = formInit.get("q");

    const searchFormated = searchQuery.trim().toLowerCase();
    fetchSearchByQuery(searchFormated);
  });

  let debounceTimeout;

  inputText?.addEventListener("keyup", (evt) => {
    console.log("key up");

    clearTimeout(debounceTimeout);

    if (evt.key === "Enter") {
      evt.preventDefault();

      const searchQuery = evt.target.value.trim();
      if (searchQuery.length > 2) {
        const searchFormated = searchQuery.toLowerCase();
        fetchSearchByQuery(searchFormated);
      }
      return;
    }

    debounceTimeout = setTimeout(() => {
      const searchQuery = evt.target.value.trim();
      if (searchQuery.length > 2) {
        const searchFormated = searchQuery.toLowerCase();
        fetchSearchByQuery(searchFormated);
      }
    }, 300);
  });

  cleanButtonText?.addEventListener("click", () => {
    formSearchHeader.reset();
    inputText.value = "";
    const containerResults = document.querySelector(".main-search__results");
    containerResults.innerHTML = "";
  });

  formSearchHeader?.addEventListener("submit", (evt) => {
    evt.preventDefault();
    evt.stopPropagation();

    const formInit = new FormData(formSearchHeader);
    const searchQuery = formInit.get("q");

    const searchFormated = searchQuery.trim().toLowerCase();
    fetchSearchByQuery(searchFormated);
  });
};

document.addEventListener("DOMContentLoaded", () => {
  geoIpPopupHandler();
  window.reInitYotpoWidgets();
  pdpYotpoModifications();
  pdpOurCommitmentHandling();
  pdpFormQuantityHandler();
  searchFormInit();
});

searchFormInit();